/*
 * @Date: 2023-07-26 15:57:05
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditTime: 2023-07-27 17:49:09
 * @Description: 监听元素显示
 * @Useage:
 *  template: <element v-displayed="handler" />
 *  JSX:
 *    const directives = [{ name: 'displayed', value: this.handler }];
 *    <div {...{ directives }}></div>
 */
class EleObserver {
  // 元素回调函数映射表
  _eleHandlerMap;
  _observer;
  constructor() {
    this._observer = new IntersectionObserver(
      elements => {
        elements.forEach(element => {
          let target = element.target;
          if (element.intersectionRatio > 0) {
            const callback = this._eleHandlerMap.get(target.getAttribute('displayed-id'));
            if (typeof callback == 'function') {
              callback();
            }
          }
        });
      },
      {
        // 0~1 相对元素自身的比例
        threshold: [0.1]
      }
    );
    this._eleHandlerMap = new Map();
  }

  add(element, displayedId, handler) {
    if (this._observer) {
      this._observer.observe(element);
      this._eleHandlerMap.set(displayedId, handler);
    }
  }

  remove(element, displayedId) {
    this._observer.unobserve(element);
    this._eleHandlerMap.delete(displayedId);
  }
}

// 判断浏览器是否支持
let observer = null;
if (window.IntersectionObserver) {
  observer = new EleObserver();
}
export default {
  // 只调用一次，指令第一次绑定到元素时调用
  bind(el, binding, vnode) {
    if (observer) {
      const displayedId = `d_${vnode.context._uid}`;
      el.setAttribute('displayed-id', displayedId);
      observer.add(el, displayedId, binding.value);
    }
  },
  // 只调用一次，指令与元素解绑时调用
  unbind(el, binding, vnode) {
    if (observer) {
      observer.remove(el, `d_${vnode.context._uid}`);
    }
  }
};
